import React, { useEffect, useState } from 'react'; // useEffectとuseStateをインポート
import { Helmet } from 'react-helmet-async'; // ★これと
import styled from 'styled-components';
import { device } from '../MainContents/Style/StyleDevice';
import HighSchoolIntroduction from "./HighSchoolIntroduction";
import SupportPointHighSchool from "./SupportPointHighSchool";
import CourceHighSchool from "./CourceHighSchool";
import QuestionHighSchool from "./QuestionHighSchool";

const Container = styled.div`
    width: 100%;
    margin: auto;
    margin-top: 170px;
    text-align: center;
    @media ${device.mobile} {
        margin-top: 80px;
    }
`;


const MainBackColorGradient = styled.div`
background: linear-gradient(
  to bottom, 
  rgba(155, 0, 63, 1) 0%,   /* 上：赤（不透明） */
  rgba(255, 69, 0, 0.7) 50%, /* 中間：orangered（半透明） */
  rgba(255, 69, 0, 0) 100%   /* 下：orangered（完全透明） */
);
`;
// ▼▼▼ 追加：お知らせ用のスタイル ▼▼▼
const NoticeContainer = styled.div`
  background-color: #fff9f9;
  border: 2px solid #e53e3e;
  border-radius: 8px;
  padding: 24px 28px;
  margin: 0 auto 35px;
  max-width: 900px;
  box-shadow: 0 4px 12px rgba(229, 62, 62, 0.08);

  @media ${device.mobile} {
    padding: 16px;
    margin: 10px auto 25px;
    width: 92%;
  }
`;

const NoticeTitle = styled.h2`
  color: #c53030;
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  margin: 0 0 16px 0;
  letter-spacing: 0.03em;

  @media ${device.mobile} {
    font-size: 16px;
    margin-bottom: 12px;
  }
`;

const NoticeText = styled.p`
  font-size: 15px;
  line-height: 1.8;
  color: #333333;
  margin: 0 0 12px 0;
  text-align: left;

  @media ${device.mobile} {
    font-size: 13.5px;
    line-height: 1.7;
  }
`;

const NoticeHighlight = styled.div`
  background-color: #fff0f0;
  border-left: 4px solid #e53e3e;
  padding: 10px 14px;
  margin: 12px 0;
  font-size: 14.5px;
  line-height: 1.7;
  color: #4a5568;

  strong {
    color: #9b2c2c;
    font-weight: 700;
  }

  @media ${device.mobile} {
    font-size: 13px;
    padding: 8px 10px;
  }
`;

const NoticePhoneBox = styled.div`
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px dashed #feb2b2;
  text-align: center;
`;

const NoticePhoneLabel = styled.div`
  font-size: 13px;
  color: #718096;
  margin-bottom: 4px;
  font-weight: 600;
`;

const NoticePhoneLink = styled.a`
  display: inline-block;
  font-size: 24px;
  font-weight: 800;
  color: #c53030;
  text-decoration: none;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
    text-decoration: underline;
  }

  @media ${device.mobile} {
    font-size: 20px;
  }
`;

const PhoneIcon = styled.span`
  font-size: 20px;
  vertical-align: middle;
  margin-right: 4px;
`;
// ▲▲▲ 追加：お知らせ用のスタイルここまで ▲▲▲
const TosayobiHighSchool = () => {
    // アニメーションクラスを適用するかどうかを管理するstate
    const [animate, setAnimate] = useState(false); // コンポーネントがマウントされた（表示された）ときにアニメーションをトリガー
    useEffect(() => {
        // 画面に表示されたことを感知したらanimateをtrueにする
        setAnimate(true);
    }, []); // 空の依存配列は、コンポーネントが初回マウントされた時のみ実行されることを意味する
    return (
        <Container>
            {/* ★ここからHelmetの記述を追加します */}
            <Helmet>
                <title>TOSAYOBI高等学院 | 高知の通信制高校</title> {/* ←ここに希望するタイトルを設定 */}
                <meta name="description" content="TOSAYOBI高等学院の公式ウェブサイトです。高知で通信制高校をお探しの方へ。" />
                {/* 必要であれば、OGPタグなどもここに追加できます */}
                <meta property="og:title" content="TOSAYOBI高等学院" />
                <meta property="og:description" content="高知県で大学受験対策もできる通信制高校をお探しならTOSAYOBI高等学院。土佐塾予備校のノウハウで、一人ひとりに寄り添い高卒資格と志望大学合格をサポートします。" />
                <meta property="og:keywords" content="高知,予備校,入試,通信制" />
                {/* <meta property="og:image" content="ここにOGP画像のURL" /> */}
            </Helmet>
            {/* TOSAYOBI高等学院とは 土佐塾予備校 × 第一学院高等学校 まで */}
      {/* ▼▼▼ 追加：重要なお知らせエリア ▼▼▼ */}
      <NoticeContainer>
        <NoticeTitle>【重要】お問い合わせフォームの一時停止について</NoticeTitle>
        
        <NoticeText>
          「PHPにおける重大な脆弱性の確認」を受けて、予防的メンテナンスとして当サイトの「お問い合わせフォーム」を一時停止しております。
        </NoticeText>

        {/* <NoticeHighlight>
          本対応はシステムの安全確保を目的とした予防措置であり、<strong>当学院における不正アクセスや個人情報の漏洩などの被害が発生したことによるものではございません。</strong>
        </NoticeHighlight> */}

        <NoticeText>
          各種ご案内ページの閲覧は通常通りご利用いただけます。<br />
          お急ぎのご用件・お問い合わせにつきましては、下記までお電話にてご連絡くださいますようお願い申し上げます。
        </NoticeText>

        <NoticePhoneBox>
          <NoticePhoneLink href="tel:0888836514">
            <PhoneIcon aria-hidden="true">📞</PhoneIcon> 088-883-6514
          </NoticePhoneLink>
        </NoticePhoneBox>
      </NoticeContainer>
      {/* ▲▲▲ 追加：重要なお知らせエリアここまで ▲▲▲ */}

            <HighSchoolIntroduction />
        </Container >
    );
};

export default TosayobiHighSchool;
